// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date_dateContainer__yUD4G {
    position: absolute;
    z-index: 998;
    padding-top: 0.2rem;
}

.date_container__gMaQy {
    position: relative;
}

.date_floatingLabel__7UtDU {
    position: absolute;
    top: -10px;
    pointer-events: none;
    left: 12px;
    display: block;
    background-color: #FFFFFF;
    font-size: 0.8rem;
    padding-left: 3px;
    padding-right: 3px;
}

.date_defaultBorder__8qBmB {
    white-space: nowrap;
    height: 43px;
    padding: 0.625rem 0.75rem !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px !important;
    font-size: 1rem !important;
    color: #334155 !important;
    background-color: #f8fafc;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.date_defaultBorder__8qBmB:focus {
    outline: none !important;
    border-color: #818cf8 !important;
    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ajonjolib/inputs/date/date.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,oCAAoC;IACpC,oCAAoC;IACpC,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;IACzB,0DAA0D;AAC9D;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,yDAAyD;AAC7D","sourcesContent":[".dateContainer {\n    position: absolute;\n    z-index: 998;\n    padding-top: 0.2rem;\n}\n\n.container {\n    position: relative;\n}\n\n.floatingLabel {\n    position: absolute;\n    top: -10px;\n    pointer-events: none;\n    left: 12px;\n    display: block;\n    background-color: #FFFFFF;\n    font-size: 0.8rem;\n    padding-left: 3px;\n    padding-right: 3px;\n}\n\n.defaultBorder {\n    white-space: nowrap;\n    height: 43px;\n    padding: 0.625rem 0.75rem !important;\n    border: 1px solid #e2e8f0 !important;\n    border-radius: 8px !important;\n    font-size: 1rem !important;\n    color: #334155 !important;\n    background-color: #f8fafc;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.defaultBorder:focus {\n    outline: none !important;\n    border-color: #818cf8 !important;\n    box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.2) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dateContainer": `date_dateContainer__yUD4G`,
	"container": `date_container__gMaQy`,
	"floatingLabel": `date_floatingLabel__7UtDU`,
	"defaultBorder": `date_defaultBorder__8qBmB`
};
export default ___CSS_LOADER_EXPORT___;
